import { getSupabaseClient } from '../supabase.ts';
import { escapeHtml } from '../main.ts';

const sb = getSupabaseClient();
const tableName = 'student_database';

export function renderDatabasePage(app: HTMLElement, forcedSession?: string): void {
  app.innerHTML = `
<style>
  .db-wrap{background:#f6f8fa;color:#24292f;font-family:system-ui,-apple-system,sans-serif;min-height:100vh}
  .db-header{background:#0d1117;color:#fff;padding:12px 20px;display:flex;align-items:center;justify-content:space-between}
  .db-header h1{font-size:20px;margin:0;font-weight:600}
  .db-header a.btn-allfields{background:#ff8a00;color:#fff;padding:8px 12px;border-radius:6px;text-decoration:none;font-size:13px;border:1px solid #ff8a00}
  .db-header a.back-btn{color:#fff;text-decoration:none;margin-right:15px;font-size:20px}
  .db-container{width:100%;max-width:100%;margin:0 0 60px 0;background:#ffffff;border:1px solid #d0d7de;padding:18px 12px 28px;box-shadow:0 2px 4px rgba(0,0,0,.04)}
  .table-wrap{overflow-x:auto}
  .toolbar{display:flex;flex-wrap:wrap;gap:12px;align-items:center;margin-bottom:14px}
  .toolbar select, .toolbar input{padding:8px 10px;border:1px solid #d0d7de;border-radius:4px;font-size:14px}
  .toolbar button{height:34px;cursor:pointer;font-size:12px;padding:6px 10px;border-radius:4px;border:1px solid #0366d6;background:#0366d6;color:#fff;font-weight:500}
  .toolbar button.outline{background:#fff;color:#0366d6}
  .status{font-size:13px;min-height:18px}
  table{width:100%;border-collapse:collapse;font-size:13.5px}
  thead{background:#fafbfc;position:sticky;top:0;z-index:5}
  th, td{border:1px solid #d0d7de;padding:6px 8px;text-align:left;vertical-align:middle}
  th{font-weight:600;font-size:12.5px;background:#f0f3f6}
  tbody tr:nth-child(even){background:#fcfcfd}
  tbody tr:hover{background:#fffbe6}
  .col-sl{width:52px;text-align:center}
  .row-thumb{width:40px;height:50px;object-fit:cover;border-radius:4px;border:1px solid #d0d7de;background:#fff;cursor:pointer}
  .btn{padding:6px 8px;font-size:12px;border-radius:4px;cursor:pointer;border:1px solid #0366d6;background:#0366d6;color:#fff}
  .btn.edit{background:#ff8a00;border-color:#ff8a00}
  .action-cell button+button{margin-left:8px}
  .modal{position:fixed;inset:0;background:rgba(0,0,0,.45);display:none;align-items:flex-start;justify-content:center;padding:60px 20px 40px;z-index:200}
  .modal .panel{background:#fff;width:880px;max-width:100%;border-radius:6px;padding:18px 20px 24px;max-height:80vh;overflow:auto}
  .status-tc{background:#fee2e2!important;color:#b91c1c!important}
  .row-fulldata-ok{background:#10b981!important;color:#fff!important}
  #photo-preview{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;border:2px solid #d0d7de;border-radius:8px;padding:12px;box-shadow:0 10px 40px rgba(0,0,0,0.35);z-index:10001;display:none;max-width:90vw;max-height:90vh;pointer-events:none}
  #photo-preview img{max-width:500px;max-height:600px;object-fit:contain}
</style>
<div class="db-wrap">
  <header class="db-header">
    <div style="display:flex;align-items:center;">
      <a href="/" class="back-btn">⬅</a>
      <h1 id="pageTitle">Student List (2026)</h1>
    </div>
    <a href="/all_data_field" class="btn-allfields">All data fields ↗</a>
  </header>
  <div class="db-container container">
    <div class="toolbar">
      <label>Session</label><select id="sessionFilter"></select>
      <label>Class</label><select id="classFilter"></select>
      <label>Section</label><select id="sectionFilter"></select>
      <div style="margin-left:auto;display:flex;gap:12px;align-items:center;">
        <button id="refreshBtn">Refresh</button>
        <span id="status" class="status"></span>
        <button id="clearFilters" class="outline">Clear</button>
      </div>
    </div>
    <div class="table-wrap">
      <table id="dataTable">
        <thead>
          <tr>
            <th class="col-sl">SL</th><th>IID</th><th>Class</th><th>Section</th><th>Roll</th>
            <th>Name</th><th>Father Name</th><th>Father Mobile</th><th>Photo</th><th>Session</th>
            <th>Status</th><th>FullData</th><th>Action</th>
          </tr>
        </thead>
        <tbody><tr><td colspan="13">Loading...</td></tr></tbody>
      </table>
    </div>
  </div>
  <div id="photo-preview"><img src="" alt="preview"/></div>
</div>
  `;

  // --- Logic Implementation ---
  let allRowsCache: any[] = [];
  const tbody = document.querySelector('#dataTable tbody')!;
  const statusEl = document.getElementById('status')!;
  const pageTitle = document.getElementById('pageTitle')!;
  const sessionFilter = document.getElementById('sessionFilter') as HTMLSelectElement;
  const classFilter = document.getElementById('classFilter') as HTMLSelectElement;
  const sectionFilter = document.getElementById('sectionFilter') as HTMLSelectElement;
  const dataCache: Record<string, any[]> = {};

  function getActiveKeys() {
    let ses = forcedSession;
    if (!ses) {
      ses = localStorage.getItem('db_ses') || sessionFilter.value || '2026';
    }
    const actualSes = ses === 'old' ? '2025' : ses;
    return { session: actualSes, classKey: `class_${actualSes}`, sectionKey: `section_${actualSes}`, rollKey: `roll_${actualSes}` };
  }

  function parseCSV(text: string): any[] {
    const lines: string[][] = [];
    let row: string[] = [];
    let cell = '';
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const nextChar = text[i + 1];

      if (inQuotes) {
        if (char === '"') {
          if (nextChar === '"') {
            cell += '"';
            i++;
          } else {
            inQuotes = false;
          }
        } else {
          cell += char;
        }
      } else {
        if (char === '"') {
          inQuotes = true;
        } else if (char === ',') {
          row.push(cell);
          cell = '';
        } else if (char === '\r' || char === '\n') {
          row.push(cell);
          cell = '';
          if (row.length > 0 && row.some(c => c.trim() !== '')) {
            lines.push(row);
          }
          row = [];
          if (char === '\r' && nextChar === '\n') {
            i++;
          }
        } else {
          cell += char;
        }
      }
    }
    if (cell || row.length > 0) {
      row.push(cell);
      if (row.some(c => c.trim() !== '')) {
        lines.push(row);
      }
    }

    if (lines.length === 0) return [];
    const headers = lines[0].map(h => h.trim());
    return lines.slice(1).map(r => {
      const obj: any = {};
      headers.forEach((h, idx) => {
        obj[h] = r[idx] !== undefined ? r[idx].trim() : '';
      });
      return obj;
    });
  }

  async function loadCSVData() {
    if (dataCache['old_csv']) {
      return dataCache['old_csv'];
    }
    const res = await fetch('/src/previous_data2025.csv');
    const text = await res.text();
    const rawRows = parseCSV(text);
    const mapped = rawRows.map((row: any) => {
      return {
        iid: row['IID'] || '',
        class_2025: row['Class'] || '',
        section_2025: row['Section'] || '',
        roll_2025: row['Roll'] || '',
        student_name_en: row['Name_en'] || '',
        father_name_en: row['Father name en'] || '',
        father_mobile: row['Phone'] || '',
        student_photo_url: '',
        session: '2025',
        status: '',
        fulldata_ok: ''
      };
    });
    dataCache['old_csv'] = mapped;
    return mapped;
  }

  async function dynamicLoadClasses() {
    const { classKey } = getActiveKeys();
    statusEl.textContent = 'Loading classes...';
    try {
      let rows: any[] = [];
      if (forcedSession === 'old') {
        rows = await loadCSVData();
      } else {
        const { data } = await sb.from(tableName).select(classKey).not(classKey, 'is', null);
        rows = data || [];
      }
      const set = new Set<string>();
      rows.forEach((r: any) => { if(r[classKey]) set.add(String(r[classKey])); });
      const list = Array.from(set).sort((a,b) => Number(a)-Number(b));
      classFilter.innerHTML = '<option value="">All</option>' + list.map(c => `<option value="${c}">${c}</option>`).join('');
      statusEl.textContent = 'Ready';
      
      const storedClass = localStorage.getItem('db_class');
      if (list.length > 0) {
        const activeClass = (storedClass && list.includes(storedClass)) ? storedClass : list[0];
        classFilter.value = activeClass;
        localStorage.setItem('db_class', activeClass);
        loadDataForClass(activeClass);
      } else {
        tbody.innerHTML = '<tr><td colspan="13">No classes found</td></tr>';
      }
    } catch(err) {
      statusEl.textContent = 'Error';
      tbody.innerHTML = '<tr><td colspan="13">Error loading classes</td></tr>';
    }
  }

  async function loadDataForClass(cls: string) {
    if (!cls) { tbody.innerHTML = '<tr><td colspan="13">Please select a class</td></tr>'; return; }
    const { session, classKey, sectionKey, rollKey } = getActiveKeys();
    const cacheKey = `${session}_${cls}`;
    
    const runSetup = (rows: any[]) => {
      allRowsCache = rows;
      
      // Populate Section Filter
      const secSet = new Set<string>();
      allRowsCache.forEach(r => { if(r[sectionKey]) secSet.add(String(r[sectionKey])); });
      const secList = Array.from(secSet).sort();
      sectionFilter.innerHTML = '<option value="">All Sections</option>' + secList.map(s => `<option value="${s}">${s}</option>`).join('');

      const storedSection = localStorage.getItem('db_section');
      if (storedSection && secList.includes(storedSection)) {
        sectionFilter.value = storedSection;
      } else {
        sectionFilter.value = '';
        localStorage.removeItem('db_section');
      }

      applyFilters();
    };

    if (dataCache[cacheKey]) {
      runSetup(dataCache[cacheKey]);
      return;
    }
    
    statusEl.textContent = 'Loading records...';
    if (forcedSession === 'old') {
      const csvData = await loadCSVData();
      const filtered = csvData.filter((r: any) => String(r[classKey]) === cls);
      filtered.sort((a: any, b: any) => Number(a[rollKey]) - Number(b[rollKey]));
      dataCache[cacheKey] = filtered;
      runSetup(filtered);
    } else {
      const cols = `iid,${classKey},${sectionKey},${rollKey},student_name_en,father_name_en,father_mobile,student_photo_url,session,status,fulldata_ok`;
      const { data, error } = await sb.from(tableName).select(cols).eq(classKey, cls).order(rollKey, { ascending: true });

      if (error) { statusEl.textContent = 'Error'; return; }
      dataCache[cacheKey] = data || [];
      runSetup(dataCache[cacheKey]);
    }
  }

  function applyFilters() {
    const { classKey, sectionKey } = getActiveKeys();
    const c = classFilter.value;
    const s = sectionFilter.value;
    let filtered = allRowsCache;
    if (c) filtered = filtered.filter(r => String(r[classKey]) === c);
    if (s) filtered = filtered.filter(r => String(r[sectionKey]) === s);
    renderTable(filtered);
    statusEl.textContent = `Total: ${filtered.length}`;
  }

  function renderTable(rows: any[]) {
    const { classKey, sectionKey, rollKey } = getActiveKeys();
    tbody.innerHTML = rows.map((r, idx) => {
      const isTC = r.status && String(r.status).toUpperCase().includes('TC');
      const isOK = r.fulldata_ok === 'OK' || String(r.fulldata_ok).trim().toUpperCase() === 'OK';
      const rowClass = isTC ? 'status-tc' : (isOK ? 'row-fulldata-ok' : '');
      
      return `
      <tr class="${rowClass}">
        <td class="col-sl">${idx+1}</td>
        <td>${r.iid}</td>
        <td>${r[classKey] ?? ''}</td>
        <td>${r[sectionKey] ?? ''}</td>
        <td>${r[rollKey] ?? ''}</td>
        <td>${escapeHtml(r.student_name_en || '')}</td>
        <td>${escapeHtml(r.father_name_en || '')}</td>
        <td>${r.father_mobile || ''}</td>
        <td><img src="${r.student_photo_url || ''}" class="row-thumb" data-iid="${r.iid}"></td>
        <td>${r.session || ''}</td>
        <td>${r.status || ''}</td>
        <td>${r.fulldata_ok || ''}</td>
        <td class="action-cell">
          <a href="/view?iid=${r.iid}" target="_blank" onclick="window.open(this.href, '_blank'); return false;" class="btn small view" style="background:#10b981; border-color:#10b981;">View</a>
          <a href="/edit_details?iid=${r.iid}" target="_blank" onclick="window.open(this.href, '_blank'); return false;" class="btn small edit">Edit</a>
        </td>
      </tr>
      `;
    }).join('') || '<tr><td colspan="13">No results</td></tr>';

    // Photo Preview Logic
    const previewEl = document.getElementById('photo-preview')!;
    const previewImg = previewEl.querySelector('img')!;
    
    tbody.querySelectorAll('.row-thumb').forEach(img => {
      img.addEventListener('mouseenter', (e: any) => {
        const src = e.target.src;
        if (src && !src.includes('placeholder')) {
          previewImg.src = src;
          previewEl.style.display = 'block';
        }
      });
      img.addEventListener('mouseleave', () => {
        previewEl.style.display = 'none';
      });
    });
  }

  const years = ['2022','2023','2024','2025','2026','2027','2028'];
  const storedSes = localStorage.getItem('db_ses');
  if (forcedSession && !years.includes(forcedSession)) {
    years.push(forcedSession);
  }
  if (storedSes && !years.includes(storedSes)) {
    years.push(storedSes);
  }
  years.sort();
  sessionFilter.innerHTML = years.map(s => `<option value="${s}">${s}</option>`).join('');
  
  const { session: initSes } = getActiveKeys();
  sessionFilter.value = initSes;
  pageTitle.textContent = `Student List (${initSes})`;

  // If forced session, hide the session selector row or disable it
  if (forcedSession) {
    const sessionLabel = sessionFilter.previousElementSibling;
    if (sessionLabel) (sessionLabel as HTMLElement).style.display = 'none';
    sessionFilter.style.display = 'none';
  }

  sessionFilter.onchange = () => {
    const ses = sessionFilter.value;
    localStorage.setItem('db_ses', ses);
    localStorage.removeItem('db_class');
    localStorage.removeItem('db_section');
    pageTitle.textContent = `Student List (${ses})`;
    dynamicLoadClasses();
  };
  classFilter.onchange = () => {
    const cls = classFilter.value;
    localStorage.setItem('db_class', cls);
    localStorage.removeItem('db_section');
    sectionFilter.value = '';
    loadDataForClass(cls);
  };
  sectionFilter.onchange = () => {
    localStorage.setItem('db_section', sectionFilter.value);
    applyFilters();
  };

  document.getElementById('refreshBtn')!.onclick = () => {
    const cls = classFilter.value;
    if (cls) {
      const { session } = getActiveKeys();
      delete dataCache[`${session}_${cls}`];
      loadDataForClass(cls);
    }
  };

  document.getElementById('clearFilters')!.onclick = () => {
    sessionFilter.value = '2026';
    classFilter.value = '';
    sectionFilter.value = '';
    localStorage.removeItem('db_ses');
    localStorage.removeItem('db_class');
    localStorage.removeItem('db_section');
    pageTitle.textContent = `Student List (2026)`;
    dynamicLoadClasses();
  };
  
  dynamicLoadClasses();
}
